import { CSSProperties } from 'react';
import { ISliderIndents } from '../../types';

interface IGetButtonWrapperStyleParams {
  indents: ISliderIndents;
}

export function getButtonWrapperStyle(params: IGetButtonWrapperStyleParams): CSSProperties {
  const { indents } = params;
  const { top = 0, bottom = 0 } = indents;

  const offset = top - (top + bottom) / 2;

  return {
    top: `calc(50% + ${offset}px)`,
  };
}
